
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.75 23.292v-9.5m8.5 1a8.5 8.5 0 00-8.5 8.5 8.5 8.5 0 008.5-8.5v0zm-16.5.5a8 8 0 018 8 8 8 0 01-8-8v0zm15-8.5a7 7 0 01-2.05 4.95 7 7 0 01-9.9 0 7 7 0 01-2.05-4.95v-5.5c0-.55.318-.682.707-.293L8.25 3.792 11.043 1a1 1 0 011.414 0l2.793 2.792L18.043 1c.389-.389.707-.257.707.293v5.499z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    